import moment from 'moment'
import { normalize, schema } from 'normalizr'
import { IMG_URL } from '../api/api'
import { getMessageForErrorCode } from '../pages/Cart/paymentLogic'
import { CartItemTypes } from '../pages/Cart/cartSlice'

export const convertToFormatted = (
    amount,
    withSymbol = false,
    stripDecimals = false
) => {
    let formatted = new Intl.NumberFormat('en-NG', {
        currency: 'NGN',
        style: 'currency',
    }).format(amount)
    if (!withSymbol) formatted = formatted.substr(withSymbol ? 0 : 1)
    if (stripDecimals)
        formatted = formatted.substring(0, formatted.indexOf('.'))
    return formatted
}

export const formatDate = (date, format = 'MMM DD, YYYY') =>
    moment(date).format(format)

export const randomInteger = max => Math.floor(Math.random() * max)

export const randomFloat = (max = 1) => Math.random() * max

export const randomItem = possibilities => {
    const i = randomInteger(possibilities.length)
    return possibilities[i]
}

export const randomBoolean = () => randomItem([true, false])

export const getNumMatches = (array, validator) =>
    array.filter(validator).length

//Acts under the assumption that you don't have parameters in the routes like /:id
export const getParentRoute = pathname =>
    pathname.substring(0, pathname.lastIndexOf('/'))

export const getNormalizedAuthors = authors => {
    const authorSchema = new schema.Entity(
        'authors',
        {},
        {
            idAttribute: 'email',
        }
    )
    return normalize(authors, [authorSchema])
}

export const getImageURL = (path, defaultUrl = '') => path || defaultUrl

export const toBytes = size => size * 1024 * 1024

/**
 * @see https://github.com/axios/axios/issues/383
 * @see https://github.com/axios/axios/issues/204
 */
export function isNetworkError(error) {
    return (
        error.name === 'NetworkError' ||
        error.message.toLowerCase().includes('network') ||
        error.message.toLowerCase().includes('timeout') ||
        !error.status ||
        (!!error?.response && !error?.response.status)
    )
}

export function getErrorMessage(error) {
    if (error.response) {
        if (error.response.data?.errorCode) {
            return getMessageForErrorCode(error)
        } else {
            return error.response.data
        }
    } else {
        if (isNetworkError(error))
            return 'A network error occured. Kindly check your internet connection'
        else
            return "Something went wrong, we're not sure what. Our team is working on it."
    }
}

export const getFreeCoursesLeft = ({ items, userFreeCourses }) => {
    const freeInCart = items.reduce((total, { type, free }) => {
        if (type === CartItemTypes.Course && free) {
            return total + 1
        }

        return total
    }, 0)

    return userFreeCourses - freeInCart >= 0 ? userFreeCourses - freeInCart : 0
}

export const getFreeClassesLeft = ({ items, userFreeClasses }) => {
    const freeInCart = items.reduce((total, { type, numFree }) => {
        if (type === CartItemTypes.Class) {
            return total + numFree
        }

        return total
    }, 0)

    return userFreeClasses - freeInCart >= 0 ? userFreeClasses - freeInCart : 0
}
